module.exports = __webpack_public_path__ + "static/media/video.c98d5fd4.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/video.mp4
// module id = 39
// module chunks = 0